import xss from "xss";

/* eslint-disable no-restricted-globals */
export function useLanguageUrlParam() {
  const locationParams = new URLSearchParams(xss(location.search));
  const langParam = locationParams.get("lang");

  return !!langParam ? `?lang=${langParam}` : "";
}
